import client from './client';

export const getWarehouses = () =>
  client.get('/warehouses').then((r) => r.data);

export const getWarehouse = (uuid) =>
  client.get(`/warehouses/${uuid}`).then((r) => r.data);

export const createWarehouse = (data) =>
  client.post('/warehouses', data).then((r) => r.data);

export const updateWarehouse = (uuid, data) =>
  client.patch(`/warehouses/${uuid}`, data).then((r) => r.data);

export const deactivateWarehouse = (uuid, businessUuid) =>
  client
    .patch(`/warehouses/${uuid}/deactivate`, { businessUuid })
    .then((r) => r.data);

export const activateWarehouse = (uuid, businessUuid) =>
  client
    .patch(`/warehouses/${uuid}/activate`, { businessUuid })
    .then((r) => r.data);

export const deleteWarehouse = (uuid, businessUuid) =>
  client
    .delete(`/warehouses/${uuid}`, { params: { businessUuid } })
    .then((r) => r.data);

export const getLocations = (warehouseUuid) =>
  client.get(`/warehouses/${warehouseUuid}/locations`).then((r) => r.data);

export const createLocation = (warehouseUuid, data) =>
  client
    .post(`/warehouses/${warehouseUuid}/locations`, data)
    .then((r) => r.data);

export const updateLocation = (uuid, data) =>
  client.patch(`/locations/${uuid}`, data).then((r) => r.data);

export const deactivateLocation = (uuid, businessUuid) =>
  client
    .patch(`/locations/${uuid}/deactivate`, { businessUuid })
    .then((r) => r.data);

export const activateLocation = (uuid, businessUuid) =>
  client
    .patch(`/locations/${uuid}/activate`, { businessUuid })
    .then((r) => r.data);

export const deleteLocation = (uuid, businessUuid) =>
  client
    .delete(`/locations/${uuid}`, { params: { businessUuid } })
    .then((r) => r.data);

export const getStockSummary = (warehouseUuid) =>
  client.get(`/warehouses/${warehouseUuid}/stock-summary`).then((r) => r.data);

export const getLocationStock = (locationUuid) =>
  client.get(`/locations/${locationUuid}/stock`).then((r) => r.data);
